import Vue from 'vue';
import Router from 'vue-router';
import store from './store/index'
import sysUtil from './util/sysUtil'

Vue.use(Router);
 

var routes = [

  {
    name: 'wechatLogin',
    component: () => import('./view/wechatLogin'),
    meta: {
      title: '登录授权'
    }
  },
  {
    name: 'customLogin',
    component: () => import('./view/customLogin'),
    meta: {
      title: '登录授权'
    }
  },
  {
    name: 'callback',
    component: () => import('./view/callback'),
    meta: {
      title: '授权认证'
    }
  },
  {
    name: 'productInfo',
    component: () => import('./view/mes/productInfo/index'),
    meta: {
      title: 'Mes标准版'
    }
  }
];

var mesRoutes = [
  {
    name: 'home',
    component: () => import('./view/mes/home'),
    meta: {
      title: 'Mes标准版'
    }
  },{
    name: 'workListDetail',
    component: () => import('./view/bussComponents/workListDetail'),
    meta: {
      title: 'Wms标准版'
    }
  },
  {
  name: 'woList',
  component: () => import('./view/mes/wo/index'),
  meta: {
    title: 'Mes标准版'
    }
  }
]

var wmsRoutes = [
  {
    name: 'home',
   // component: () => import('./view/mes/home'),
    component: () => import('./view/wms/home'),
    meta: {
      title: 'Wms标准版'
    }
  },
  {
    name: 'materialReceive',
    component: () => import('./view/wms/materialReceive/index'),
    meta: {
      title: 'Wms标准版'
    }
  },{
    name: 'checkOut',
    component: () => import('./view/wms/checkOut/index'),
    meta: {
      title: 'Wms标准版'
    }
  },{
    name: 'pickMaterials',
    component: () => import('./view/wms/pickMaterials/index'),
    meta: {
      title: 'Wms标准版'
    }
  },{
    name: 'returnMaterial',
    component: () => import('./view/wms/returnMaterial/index'),
    meta: {
      title: 'Wms标准版'
    }
  },{
    name: 'merchandiseSales',
    component: () => import('./view/wms/merchandiseSales/index'),
    meta: {
      title: 'Wms标准版'
    }
  },{
    name: 'merchandiseSales1',
    component: () => import('./view/wms/merchandiseSales1/index'),
    meta: {
      title: 'Wms标准版'
    }
  },{
    name: 'enterStore',
    component: () => import('./view/wms/enterStore/index'),
    meta: {
      title: 'Wms标准版'
    }
  },{
    name: 'outOfStore',
    component: () => import('./view/wms/outOfStore/index'),
    meta: {
      title: 'Wms标准版'
    }
  },{
    name: 'storeCheck',
    component: () => import('./view/wms/storeCheck/index'),
    meta: {
      title: 'Wms标准版'
    }
  },{
    name: 'storeQuery',
    component: () => import('./view/wms/storeQuery/index'),
    meta: {
      title: 'Wms标准版'
    }
  },{
    name: 'compareAllocate',
    component: () => import('./view/wms/compareAllocate/index'),
    meta: {
      title: 'Wms标准版'
    }
  },{
    name: 'absoluteAllocate',
    component: () => import('./view/wms/absoluteAllocate/index'),
    meta: {
      title: 'Wms标准版'
    }
  },{
    name: 'compareInstore',
    component: () => import('./view/wms/compareInstore/index'),
    meta: {
      title: 'Wms标准版'
    }
  },{
    name: 'workListDetail',
    component: () => import('./view/bussComponents/workListDetail'),
    meta: {
      title: 'Wms标准版'
    }
  },{
    name: 'absoluteReceive',
    component: () => import('./view/wms/absoluteReceive/index'),
    meta: {
      title: 'Wms标准版'
    }
  },{
    name: 'compareReceive',
    component: () => import('./view/wms/compareReceive/index'),
    meta: {
      title: 'Wms标准版'
    }
  },{
    name: 'compareSales',
    component: () => import('./view/wms/compareSales/index'),
    meta: {
      title: 'Wms标准版'
    }
  }
]

var dynamicRoutes = {
  mes:mesRoutes,
  wms:wmsRoutes
}

if(store.state.app.curApp == null){  //默认APP为MES
  store.commit('app/SET_CURAPP', 'mes')
  routes.push(...mesRoutes);
}
else{
  var r = dynamicRoutes[store.state.app.curApp];
  routes.push(...r);
}

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});

const router = new Router({ 
  routes:routes,
 // mode: 'hash'
});

router.beforeEach(async (to, from, next) => {
  if(!sysUtil.isSysInit)
    await sysUtil.sysInit();

  const title = to.meta && to.meta.title;

  if (title) {
    document.title = title;
  }

  if(to.path == '/callback' || to.path == '/productInfo'){
    next();
  }
  else if( (store.state.authorize.token == null || to.path == '/login') && (to.path != '/wechatLogin') &&(to.path != '/customLogin') ){
    var url = store.state.app.sysConfig.useWechatApi?'/wechatLogin':'/customLogin';
    next(url);
  }
  else if(to.path == '/' )
  {
    next('/home');
  }
  else{
    next();
  }
});

export {
  router
};
